/* eslint-disable @typescript-eslint/no-use-before-define */
/* eslint-disable no-restricted-syntax */
import {createAsyncThunk, createSlice, PayloadAction} from '@reduxjs/toolkit'
import {useSelector} from 'react-redux'
import {ListItemType} from 'hiya-common/src/reducers/commonTypes'
import {http} from 'hiya-common/src/utils/axios'
import {getGameId} from 'hiya-common/src/utils/helper'
import {getGameBetChip, setGameBetChip} from './constant'
import Style from './style.json'

// 角色信息
export enum RoleEnum {
  普通 = 0,
  房主 = 1,
  管理员 = 2,
}

export enum StatusEnum {
  // 0:下注阶段;1:开奖中阶段;2:开奖结果展示阶段
  bet = 0,
  preparing = 1,
  showRes = 2,
}

export enum resStatusEnum {
  // 0: 未参与本轮;1:赢了;2:输了
  notInvolved = 0,
  win = 1,
  lose = 2,
}
export enum RankTypeEnum {
  // 榜单类型: 1: 日榜;2:周榜;3:月榜
  daily = 1,
  week,
  monthly,
}
export enum GameTypeEnum {
  猜宝箱 = 1,
  greedyHiya = 2,
  tp = 3,
  新转盘 = 4,
  slot = 5,
  greedypro = 6,
  Greedy模板游戏 = 14,
}
export enum ActionTypeEnum {
  none = 0, // 无任何交互
  reward = 1, // 领取免单卡弹窗交互
  card = 2, // 有未使用的免单卡弹窗教诲, 对应card_list 字段信息
  entry = 3, // 展示限时回归任务入口，对应jobs_enter字段信息
}
// 主接口
export const greedy_game_homepage = createAsyncThunk(
  'greedyCat_game_homepage',
  async (arg: any, store: any) => {
    const {deviceinfo, path} = store.getState().env
    const resp = await http.post(
      '/live/ground/gy_g_homepage',
      {
        ...deviceinfo,
        game_id: getGameId(path),
        game_tid: getGameId(path),
        room_id: deviceinfo.h_web_room_id,
        ...arg,
      },
      {
        store,
        xcErrorToast: true,
      }
    )
    return resp.data.data
  }
)
// 结果接口
export const greedy_game_result = createAsyncThunk(
  'greedyCat_game_result',
  async (arg: any, store: any) => {
    // 每次获取开奖结果的时候将之前的结果清空
    const {deviceinfo, path} = store.getState().env
    const resp = await http.post(
      '/live/ground/gy_g_result',
      {
        ...deviceinfo,
        game_id: getGameId(path),
        game_tid: getGameId(path),
        room_id: deviceinfo.h_web_room_id,
        ...arg,
      },
      {
        store,
        xcErrorToast: true,
      }
    )
    return resp.data.data
  }
)
// 下注接口
export const greedy_game_bet = createAsyncThunk(
  'greedyCat_game_bet',
  async (
    arg: {target_id: number; bet_coins?: number; recommend?: boolean},
    store: any
  ) => {
    const {
      deviceinfo,
      path,
      otherInfo: {from},
    } = store.getState().env
    const resp = await http.post<HiyaRes<any>>(
      '/live/ground/gy_g_bet',
      {
        ...deviceinfo,
        game_id: getGameId(path),
        game_tid: getGameId(path),
        room_id: deviceinfo.h_web_room_id,
        ...arg,
        source: from,
      },
      {
        store,
        xcErrorToast: true,
      }
    )
    return resp.data.data
  }
)

// 新用户礼包接口
export const greedy_tmpl_newer_fplay_main = createAsyncThunk(
  'greedyCat_tmpl_newer_fplay_main',
  async (arg: any, store: any) => {
    const {deviceinfo, path, otherInfo} = store.getState().env
    const resp = await http.post<HiyaRes<any>>(
      '/live/ground/gy_tmpl_newer_fplay_main',
      {
        ...deviceinfo,
        game_tid: getGameId(path),
        room_id: deviceinfo?.h_web_room_id,
        pre_load: otherInfo?.from === 'config_preload', // from 为 config_preload 代表预加载 是否预加载
        ...arg,
      },
      {
        store,
        xcErrorToast: true,
      }
    )
    return resp.data.data
  }
)
interface res_type {
  target_id: number
  icon: string
}

export interface round_res_type extends res_type {
  big_reward_flag: boolean
  big_reward_type?: 1 | 2
  round_no?: string
  round_target: number
}
interface food_res_type extends res_type {
  name: string
}
export interface normal_target_res_type {
  type: 1 | 2 // 1蔬菜 2肉
  target_id: number
  odds: number
  hot_topn: number // 1，2，3有效
  bet_amounts: number // 下注额度
  total_bet_amounts: number // 用户自己的总下注额度
  is_recommended: boolean
  total_bet?: number // 总下注额
  token_list?: {
    [key: string]: number[]
  }
  bet_plays?: number
}
export interface order_log_list_type {
  round_no: string
  win_num: number
  ct: string
}
interface round_rank_type {
  zy_id: string
  nick_name: string
  icon: string
  coin_nums: number
  rank_no: number
}
export interface loading_conf {
  bg: string
  outerProcess: string
  process: string
  text: string
}
export interface betArea_conf {
  title: string
  chip: string
  chipSelected: string
  result: string
  resultBg: string
  resultBorder: string
  freeColor?: string
  freeBg?: string
}
export interface main_conf {
  targetColor: string
  ruleColor: string
  timeColor: string
  targetSelfColor: string
  plateTextColor: string
  ruleBtnColor: string
}
export interface betRecord_conf {
  bg: string
  titleColor: string
  listBg: string
  coinCountColor: string
  roundColor: string
  dateColor: string
}
export interface gameRank_conf {
  bg: string
  tabBg: string
  tabSelectedBg: string
  tabTextColor: string
  tabTextSelectedColor: string
  ownBg: string
  titleColor: string
  coinCountColor: string
  nameColor: string
  rankColor: string
  ownRankColor: string
  ownNameColor: string
  ownCoinCountColor: string
}

export interface money_conf {
  textColor: string
  divColor: string
}

export interface guide_conf {
  guideBg: string
  bg: string
  text: string
  btnBg: string
  btnText: string
  borderTopColor: string
  borderBottomColor: string
  borderTopRightColor?: string
  awardBackground?: string
  awardTextColor?: string
  receiveTextColor?: string
  awardBDescColor?: string
}

export interface result_conf {
  numColor: string
  midColor: string
  timeColor: string
  textColor: string
}

export interface secPage_conf {
  titleColor: string
  bgColor: string
  emptyTextColor: string
}
export interface history_conf {
  itemBgColor: string
  leftTitleColor: string
  leftTimeColor: string
  rightColor: string
  cardColor: string
}
export interface rule_conf {
  titleColor: string
  textColor: string
}

export interface record_conf {
  borderColor: string
  innerBorderColor: string
  evenColor: string
  singelColor: string
  textColor: string
}

export interface rank_conf {
  tabBgColor: string
  tabActColor: string
  tabTextColor: string
  tabActTextColor: string
  nameColor: string
  scoreColor: string
  ownRank: string
  ownName: string
  coinBorderColor1: string
  coinBgColor1: string
  coinBorderColor2: string
  coinBgColor2: string
  coinBorderColor3: string
  coinBgColor3: string
}
interface InitialStateType {
  // 数据完成标记
  hasDataDone: boolean
  // 前置工作标记
  hasPreLoadedAct: boolean
  // 加载页面
  isLoading: boolean
  // 主接口内容
  home: {
    // 开奖轮次唯一性ID
    round_no?: string
    // 当前轮次/日
    day_round?: number
    // 金币余额
    coin_num?: number
    // 今日赢钱总数
    today_win?: number
    // 普通食物列表
    normal_targets?: Array<normal_target_res_type>
    // 特殊标的（肉、蔬菜）
    special_targets?: Array<normal_target_res_type>
    // 	当前轮次的状态:0:下注阶段;1:开奖中阶段;2:开奖结果展示阶段
    round_status?: StatusEnum
    // 本轮的中奖标的ID,
    round_target?: number
    // 	当前状态的剩余时间: 秒数
    status_expire?: number
    // 	单次可下注金额列表 -1 代表推荐
    bet_prices?: Array<number>
    // 	历史期号开奖阶段，按开奖期号倒序排列
    history_result?: Array<round_res_type>
    // 主页面数据
    ui_config?: any
    // 图片config 通过ui_config转化获得
    img_ui_config?: any
    // style样式 通过ui_config转化获得
    styleConfig?: {
      loading: loading_conf
      betArea: betArea_conf
      main: main_conf
      guide: guide_conf
      money: money_conf
      result: result_conf
      secPage: secPage_conf
      history: history_conf
      rule: rule_conf
      record: record_conf
      rank: rank_conf
    }
    // 默认下注额度 有下注历史则用上次历史 没有则用这个
    default_bet_price?: number
    // 0 普通 1 房主 2 管理员
    role?: number
    // 选择的下注金额下标
    betChip?: number
    // 命中的target
    hit_target?: number
    // 是否下注过，如果下注过的话就不需要展示手势
    betted?: boolean
    // 每一轮下注上限
    round_bet_limit?: number
    // 是否迎新使用
    is_wnp?: boolean
    // 展示下注动画
    show_bet_play?: boolean
    // 免费卡数量
    card_list?: {
      value?: number
      num?: number
    }[]
  }
  // 结果信息
  result_info: {
    // 轮次id
    round_no?: string
    // 赢取的金币数量
    win_coins?: number
    // 本轮下注总金额
    bet_coins?: number
    // 轮次中奖标的ID
    round_target?: number
    //	是否开大奖
    big_reward_flag?: boolean
    // 本轮中奖金额top3
    round_rank?: Array<round_rank_type>
    // 大奖类型:1:蔬菜;2:肉
    big_reward_type?: 1 | 2
    // 本轮的状态:0: 未参与本轮;1:赢了;2:输了
    status?: resStatusEnum
    newer_task_reward?: {
      card_value: number // 卡片
      card_num: number // 卡片数量
      reward_icon?: string // 卡片icon
    }
  }
  // 新用户奖励信息
  newer_main?: {
    action_type?: 0 | 1 // 0-无 1-命中新人大礼包
    newer_reward?: {
      card_value: number // 卡片
      card_num: number // 卡片数量
      reward_icon?: string // 卡片icon
    }
  }
}

const initialState: InitialStateType = {
  hasDataDone: false,
  hasPreLoadedAct: false,
  isLoading: true, // 默认加载加载页面
  home: {
    status_expire: 30,
  },
  result_info: {},
  newer_main: {},
}

export const GameGreedyMoldSlice = createSlice({
  name: 'GreedyCat',
  initialState,
  reducers: {
    // 加载页面完成
    finishedLoading: (state) => {
      Object.assign(state, {
        ...state,
        isLoading: false,
      })
    },
    // 前置流程标记完成
    finishedPreLoadedAct: (state) => {
      Object.assign(state, {
        hasPreLoadedAct: true,
      })
    },
    // 更改下注
    changeBetChip: (state, action: PayloadAction<number>) => {
      setGameBetChip(action.payload)
      Object.assign(state.home, {
        betChip: action.payload,
      })
    },
    // setHomePage
    setHomePage: (
      state,
      action: PayloadAction<{
        game_tid: number
        status: StatusEnum
        status_expire: number
        hit_target: number
        round_no: string
      }>
    ) => {
      Object.assign(state.home, {
        ...action.payload,
        round_target: action.payload?.hit_target,
        round_status: action.payload?.status,
      })
    },
    // hot_topn 当前轮次下注热榜排名,默认值:0(忽略),大于0才有意义
    updateHotFoods: (
      state,
      action: PayloadAction<{
        game_tid?: number
        mid?: string
        target_list: {
          target_id: number
          hot_topn: number
          bet_amounts?: number
          is_recommended?: boolean
          total_bet?: number
          token_list?: {
            [key: string]: number[]
          }
        }[]
      }>
    ) => {
      if (!action.payload?.target_list?.length) {
        return
      }
      const {mid} = action.payload
      const {home} = state
      const {normal_targets} = home
      let showPlay = false
      normal_targets?.forEach((f, fIdx) => {
        const item = action.payload?.target_list?.find(
          (nf) => nf.target_id === f.target_id
        )
        if (item) {
          normal_targets[fIdx].hot_topn = item.hot_topn || 0
          normal_targets[fIdx].is_recommended = item.is_recommended || false
          normal_targets[fIdx].token_list = item.token_list || {}
          // 计算需要播放的动效次数  抛出掉自己
          let arr = []
          if (item.token_list) {
            Object.keys(item.token_list).forEach((ite) => {
              if (String(ite) !== String(mid)) {
                arr = [...arr, ...item.token_list[ite]]
              }
            })
          }
          // 只有有其他人下注 才可以改变total
          if (arr?.length > 0) {
            normal_targets[fIdx].total_bet = item.total_bet || 0
          }
          normal_targets[fIdx].bet_plays = arr?.length || 0
          if (arr?.length > 0) {
            showPlay = true
          }
        } else {
          // 如果更新的数组里面没有当前的下注物 就直接将当前的下注物置为不热门即可
          normal_targets[fIdx].hot_topn = 0
          normal_targets[fIdx].is_recommended = false
          normal_targets[fIdx].total_bet = 0
          normal_targets[fIdx].token_list = {}
          normal_targets[fIdx].bet_plays = 0
        }
      })
      Object.assign(state.home, {
        normal_targets,
        show_bet_play: showPlay,
      })
    },
    // updateCoins
    updateCoins: (
      state,
      action: PayloadAction<{
        mid?: number
        coins?: number
      }>
    ) => {
      Object.assign(state.home, {
        coin_num: action.payload?.coins,
      })
    },
    // 改变其他用户动画播放
    changeBetPlay: (state, action: PayloadAction<boolean>) => {
      Object.assign(state.home, {
        show_bet_play: action.payload,
      })
    },
    // 用户下注，更改normal_targets
    changeNormalTargets: (
      state,
      action: PayloadAction<{
        target_list: {
          target_id: number
          hot_topn: number
          bet_amounts: number
          is_recommended?: boolean
          total_bet?: number
          token_list?: {
            [key: string]: number[]
          }
        }[]
      }>
    ) => {
      if (!action.payload?.target_list?.length) {
        return
      }
      const {home} = state
      const {normal_targets} = home
      const showPlay = false
      normal_targets?.forEach((f, fIdx) => {
        const item = action.payload?.target_list?.find(
          (nf) => nf.target_id === f.target_id
        )
        if (item) {
          normal_targets[fIdx].hot_topn = item.hot_topn || 0
          normal_targets[fIdx].bet_amounts = item.bet_amounts || 0
          normal_targets[fIdx].is_recommended = item.is_recommended || false
          normal_targets[fIdx].total_bet = Math.max(
            item.total_bet || 0,
            normal_targets[fIdx].total_bet
          )
        } else {
          // 如果更新的数组里面没有当前的下注物 就直接将当前的下注物置为不热门即可
          normal_targets[fIdx].hot_topn = 0
          normal_targets[fIdx].is_recommended = false
          normal_targets[fIdx].total_bet = 0
          normal_targets[fIdx].bet_plays = 0
        }
      })
      Object.assign(state.home, {
        normal_targets,
        show_bet_play: showPlay,
      })
    },
    // 改变金币卡数量
    changeBetCardList: (
      state,
      action: PayloadAction<{
        card_list: {
          value?: number
          num?: number
        }[]
      }>
    ) => {
      Object.assign(state.home, {
        card_list: [...action.payload.card_list],
      })
    },
  },
  extraReducers: (builder) => {
    // 主接口
    builder.addCase(greedy_game_homepage.fulfilled, (state, action) => {
      const {img_ui_config} = state.home
      const {
        round_status,
        normal_targets,
        ui_config,
        role,
        bet_prices = [],
        default_bet_price,
        is_wnp,
      } = action.payload
      // 是主播或者房主 并且不是迎新房 则bet_prices 增加一个推荐
      const betPrices = bet_prices.slice()
      if (role && !is_wnp) {
        betPrices.push(-1)
      }
      // 默认下注额度
      let betChip
      const curChip = getGameBetChip()
      if (betPrices?.some((ite) => ite === curChip)) {
        betChip = curChip
      } else {
        betChip = default_bet_price || bet_prices[0]
        setGameBetChip(default_bet_price)
      }
      // 默认的是否下注 是否的
      let betted = false
      // 只有是下注阶段的时候 才去检查是否有下注
      if (round_status === StatusEnum.bet) {
        betted = normal_targets?.some((f) => f.bet_amounts > 0)
      }
      // 判断配置是不是空对象
      const isSpace = ui_config ? Object.keys(ui_config).length === 0 : true
      Object.assign(state.home, {
        ...action.payload,
        normal_targets: normal_targets?.map((ite) => {
          return {...ite, total_bet_amounts: ite.bet_amounts}
        }),
        bet_prices: betPrices,
        img_ui_config: isSpace ? img_ui_config : ui_config,
        styleConfig:
          'style-1.json' in ui_config
            ? JSON.parse(ui_config?.['style-1.json'])
            : Style,
        // styleConfig: Style,
        betChip,
        betted,
      })
      Object.assign(state, {
        hasDataDone: true,
      })
    })
    // 结果接口 用于获取指定结果和其他
    builder.addCase(greedy_game_result.fulfilled, (state, action) => {
      Object.assign(state.result_info, action.payload)
    })
    builder.addCase(greedy_game_bet.fulfilled, (state, action) => {
      const {target_list, coin_num} = action.payload
      // 默认的是否下注 是否的
      let betted = false
      betted = target_list?.some((f) => f.bet_amounts > 0)
      const {home} = state
      const {normal_targets} = home
      normal_targets?.forEach((f, fIdx) => {
        const item = target_list?.find((nf) => nf.target_id === f.target_id)
        if (item) {
          normal_targets[fIdx].total_bet_amounts = item.bet_amounts || 0
          normal_targets[fIdx].total_bet = item.total_bet || 0
        }
      })
      if (target_list?.length) {
        Object.assign(state.home, {
          normal_targets,
          coin_num,
          betted,
        })
      }
    })
    builder.addCase(greedy_tmpl_newer_fplay_main.fulfilled, (state, action) => {
      Object.assign(state.newer_main, action.payload)
    })
  },
})
export default GameGreedyMoldSlice.reducer
export const useGameGreedyMoldState = () => {
  const data = useSelector((state) => state.Animal_Mink)
  return data
}
export const GameGreedyMoldActions = GameGreedyMoldSlice.actions
